/*
 * register-form.js
 * 新設する会員登録フォーム用ヘルパー（Bonify / jQuery 非依存）
 *
 * フォーム構造の前提:
 *   識別子は input/select ではなく、ラッパー div.cf-field の class に付く。
 *   例) <div class="cf-field customer-address-zip"><input name="default_address.zip"></div>
 *       <div class="cf-field customer-birthday-y"><div class="cf-select-wrap"><select name="birthday_y">…</select></div></div>
 *
 * 機能:
 *   (A) 郵便番号検索（zipcloud）→ 都道府県(英語value) / 市区町村 / 番地 を自動入力
 *   (B) 生年月日の存在チェック（うるう年対応、2/30 等をエラー表示）
 */
(function () {
  "use strict";

  /* ============================================================
   * 共通ユーティリティ
   * ========================================================== */

  // ラッパークラス内の入力要素を取得（.cf-field.<cls> の中の input / select）
  function field(wrapperClass, childSelector) {
    var wrap = document.querySelector("." + wrapperClass);
    return wrap ? wrap.querySelector(childSelector) : null;
  }

  // 値をセットし、アプリ側（React等の制御コンポーネント）の内部stateにも確実に反映させる。
  // React は value セッターを上書きし _valueTracker で変更を検知するため、
  // el.value = x だけでは「変更なし」と判定され state が更新されない。
  // → プロトタイプのネイティブ value セッターで値を入れてから input/change を発火する。
  function setValue(el, value) {
    if (!el) return;

    var proto;
    if (el instanceof window.HTMLTextAreaElement) {
      proto = window.HTMLTextAreaElement.prototype;
    } else if (el instanceof window.HTMLSelectElement) {
      proto = window.HTMLSelectElement.prototype;
    } else {
      proto = window.HTMLInputElement.prototype;
    }

    var nativeSetter = Object.getOwnPropertyDescriptor(proto, "value");
    nativeSetter = nativeSetter && nativeSetter.set;

    if (nativeSetter) {
      nativeSetter.call(el, value);
    } else {
      el.value = value;
    }

    // React の _valueTracker を使っている場合は直前値も同期しておく（二重保険）
    if (el._valueTracker && typeof el._valueTracker.setValue === "function") {
      el._valueTracker.setValue("");
    }

    el.dispatchEvent(new Event("input", { bubbles: true }));
    el.dispatchEvent(new Event("change", { bubbles: true }));
  }

  /* ============================================================
   * (A) 郵便番号検索
   * ========================================================== */

  // zipcloud が返す都道府県(日本語) → 都道府県 select の英語 value
  var PREF = {
    "北海道": "Hokkaidō", "青森県": "Aomori", "岩手県": "Iwate", "宮城県": "Miyagi",
    "秋田県": "Akita", "山形県": "Yamagata", "福島県": "Fukushima", "茨城県": "Ibaraki",
    "栃木県": "Tochigi", "群馬県": "Gunma", "埼玉県": "Saitama", "千葉県": "Chiba",
    "東京都": "Tōkyō", "神奈川県": "Kanagawa", "新潟県": "Niigata", "富山県": "Toyama",
    "石川県": "Ishikawa", "福井県": "Fukui", "山梨県": "Yamanashi", "長野県": "Nagano",
    "岐阜県": "Gifu", "静岡県": "Shizuoka", "愛知県": "Aichi", "三重県": "Mie",
    "滋賀県": "Shiga", "京都府": "Kyōto", "大阪府": "Ōsaka", "兵庫県": "Hyōgo",
    "奈良県": "Nara", "和歌山県": "Wakayama", "鳥取県": "Tottori", "島根県": "Shimane",
    "岡山県": "Okayama", "広島県": "Hiroshima", "山口県": "Yamaguchi", "徳島県": "Tokushima",
    "香川県": "Kagawa", "愛媛県": "Ehime", "高知県": "Kōchi", "福岡県": "Fukuoka",
    "佐賀県": "Saga", "長崎県": "Nagasaki", "熊本県": "Kumamoto", "大分県": "Ōita",
    "宮崎県": "Miyazaki", "鹿児島県": "Kagoshima", "沖縄県": "Okinawa"
  };

  function searchAddress() {
    var zip = field("customer-address-zip", "input");
    if (!zip) return;

    var code = zip.value.replace(/-/g, "").trim();
    if (code.length !== 7 || isNaN(code)) {
      alert("正しい郵便番号を入力してください");
      return;
    }

    fetch("https://zipcloud.ibsnet.co.jp/api/search?zipcode=" + code)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status === 200 && data.results) {
          var a = data.results[0];
          // 都道府県: select でも input でも対応。英語 value を代入
          setValue(field("customer-address-province", "select, input"), PREF[a.address1] || a.address1);
          setValue(field("customer-address-city", "input"), a.address2);
          setValue(field("customer-address-address1", "input"), a.address3);
        } else {
          alert("郵便番号に対応する住所が見つかりませんでした");
        }
      })
      .catch(function () {
        alert("住所検索中にエラーが発生しました");
      });
  }

  // 郵便番号欄の直後に検索ボタンを自動生成
  function addSearchButton() {
    var zip = field("customer-address-zip", "input");
    if (!zip || document.getElementById("searchAddress")) return;

    var btn = document.createElement("button");
    btn.type = "button";
    btn.id = "searchAddress";
    btn.textContent = "郵便番号検索";
    zip.parentNode.insertBefore(btn, zip.nextSibling);
    btn.addEventListener("click", searchAddress);
  }

  /* ============================================================
   * (B) 生年月日の存在チェック
   * ========================================================== */

  function getBirthdaySelects() {
    return {
      y: field("customer-birthday-y", "select"),
      m: field("customer-birthday-m", "select"),
      d: field("customer-birthday-d", "select")
    };
  }

  function isValidDate(year, month, day) {
    if (!year || !month || !day) return true; // 未入力はここでは判定しない

    year = parseInt(year, 10);
    month = parseInt(month, 10);
    day = parseInt(day, 10);

    if (month < 1 || month > 12) return false;

    var daysInMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (month === 2) {
      var isLeap = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
      if (isLeap) daysInMonth[1] = 29;
    }
    return day >= 1 && day <= daysInMonth[month - 1];
  }

  function initBirthdayValidation() {
    var sel = getBirthdaySelects();
    if (!sel.y || !sel.m || !sel.d) return false;
    if (sel.d.dataset.bsBirthdayBound === "1") return true; // 二重バインド防止

    // エラーメッセージ表示用の要素を生成（誕生日「日」フィールドの直後）
    var errorDiv = document.getElementById("date-error");
    if (!errorDiv) {
      errorDiv = document.createElement("div");
      errorDiv.id = "date-error";
      errorDiv.style.cssText = "color:red;font-size:14px;display:none;font-weight:bold;";
      var dayWrap = document.querySelector(".customer-birthday-d");
      if (dayWrap && dayWrap.parentNode) {
        dayWrap.parentNode.insertBefore(errorDiv, dayWrap.nextSibling);
      } else {
        sel.d.parentNode.appendChild(errorDiv);
      }
    }

    function validate() {
      var y = sel.y.value, m = sel.m.value, d = sel.d.value;
      if (y && m && d && !isValidDate(y, m, d)) {
        errorDiv.textContent = "存在しない日付が選択されています。正しい日付を選択してください。";
        errorDiv.style.display = "block";
      } else {
        errorDiv.textContent = "";
        errorDiv.style.display = "none";
      }
    }

    sel.y.addEventListener("change", validate);
    sel.m.addEventListener("change", validate);
    sel.d.addEventListener("change", validate);
    sel.d.dataset.bsBirthdayBound = "1";
    return true;
  }

  /* ============================================================
   * 初期化（フォームが動的描画される場合に対応）
   * ========================================================== */

  function init() {
    addSearchButton();
    initBirthdayValidation();
  }

  // 1. 即時 + ロード時
  init();
  document.addEventListener("DOMContentLoaded", init);
  window.addEventListener("load", init);

  // 2. 動的生成を監視（両機能の対象が揃ったら監視停止）
  var observer = new MutationObserver(function () {
    addSearchButton();
    initBirthdayValidation();

    var zipReady = !!document.getElementById("searchAddress");
    var sel = getBirthdaySelects();
    var birthdayReady = !!(sel.d && sel.d.dataset.bsBirthdayBound === "1");
    if (zipReady && birthdayReady) observer.disconnect();
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // 3. 保険の定期リトライ（最大10回）
  var retries = 0;
  var timer = setInterval(function () {
    retries++;
    init();
    var sel = getBirthdaySelects();
    var done = document.getElementById("searchAddress") && sel.d && sel.d.dataset.bsBirthdayBound === "1";
    if (done || retries >= 10) clearInterval(timer);
  }, 1000);
})();
